module.exports = __webpack_public_path__ + "static/img/b1_body.0ff1f77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/childrens/b1_body.png
// module id = CKJT
// module chunks = 1